import { render, staticRenderFns } from "./AllStudents.vue?vue&type=template&id=1a380c81"
import script from "./AllStudents.vue?vue&type=script&lang=js"
export * from "./AllStudents.vue?vue&type=script&lang=js"
import style0 from "./AllStudents.vue?vue&type=style&index=0&id=1a380c81&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports